import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import {
	check_two_bend_bay,
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function Square_bend() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");
	const [measurtement_bc, set_measurtement_bc] = useState("");
	const [measurtement_cd, set_measurtement_cd] = useState("");

	const [measurtement_ac, set_measurtement_ac] = useState("");
	const [measurtement_ad, set_measurtement_ad] = useState("");
	const [measurtement_bd, set_measurtement_bd] = useState("");

	const [measurtement_1a, set_measurtement_1a] = useState("");
	const [measurtement_d2, set_measurtement_d2] = useState("");

	// console.log(measurtement_ab);

	let does_it_work = check_two_bend_bay(
		measurtement_cd,
		measurtement_ab,
		measurtement_bc,
		measurtement_ac,
		measurtement_ad,
		measurtement_bd
	);
	let the_summary = "(empty)";

	useEffect(() => {
		let svg_wrap = document.querySelector(".svg_wrap");
		//console.log("height: ", svg_wrap.classHeight);
	});

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>Square</strong> bay
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 150">
						<path
							fill="#7BAABD"
							fillRule="evenodd"
							clipRule="evenodd"
							d="M56 26a4 4 0 0 1 4-4h210a4 4 0 0 1 4 4v86h52a4 4 0 0 1 0 8h-56a4 4 0 0 1-4-4V30H64v86a4 4 0 0 1-4 4H4a4 4 0 0 1 0-8h52V26Z"
						/>
						<path
							fill="#D4D0C4"
							fillRule="evenodd"
							clipRule="evenodd"
							d="M68.6 34.4c.3-.7 1.2-1.1 2-.8l2.6 1.1a1.5 1.5 0 1 1-1.1 2.8l-2.7-1.1a1.5 1.5 0 0 1-.8-2Zm192.8 0c.3.8 0 1.7-.8 2l-2.7 1a1.5 1.5 0 1 1-1.1-2.7l2.6-1c.8-.4 1.7 0 2 .7ZM76.5 37.8c.4-.8 1.2-1.2 2-.8l5.3 2.2a1.5 1.5 0 1 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm177 0c.3.7 0 1.6-.8 2l-5.3 2.1a1.5 1.5 0 0 1-1.2-2.7l5.3-2.2c.8-.4 1.6 0 2 .8ZM87 42.2c.3-.8 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 0 1-1.1 2.8l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm155.8 0c.3.8 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.1-2.8l5.2-2.2c.8-.3 1.7 0 2 .8ZM97.6 46.6c.4-.7 1.2-1 2-.8l5.3 2.3a1.5 1.5 0 1 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm134.8 0c.3.8 0 1.7-.8 2l-5.3 2.2a1.5 1.5 0 0 1-1.2-2.7l5.3-2.3c.8-.3 1.6 0 2 .8Zm-124.2 4.5c.3-.8 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 1 1-1.1 2.8L109 53a1.5 1.5 0 0 1-.8-2Zm113.6 0c.3.7 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.1-2.8l5.2-2.2c.8-.3 1.7 0 2 .8Zm-103 4.4c.3-.7 1.2-1 2-.8L126 57a1.5 1.5 0 0 1-1.2 2.7l-5.2-2.2a1.5 1.5 0 0 1-.8-2Zm92.4 0c.4.8 0 1.7-.8 2l-5.2 2.2A1.5 1.5 0 1 1 204 57l5.3-2.3c.7-.3 1.6 0 2 .8ZM129.3 60c.3-.8 1.2-1.1 2-.8l5.3 2.2a1.5 1.5 0 1 1-1.2 2.8l-5.3-2.3a1.5 1.5 0 0 1-.8-2Zm71.4 0c.3.7 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.2-2.8l5.3-2.2c.8-.3 1.7 0 2 .8Zm-60.8 4.4c.3-.7 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 0 1-1.2 2.8l-5.2-2.2a1.5 1.5 0 0 1-.8-2Zm50.2 0c.4.8 0 1.7-.8 2l-5.2 2.2a1.5 1.5 0 1 1-1.2-2.8l5.3-2.2c.7-.3 1.6 0 2 .8ZM150.4 69c.3-.8 1.2-1.2 2-.8l5.3 2.2a1.5 1.5 0 1 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm29.2 0c.3.7 0 1.6-.8 2l-5.3 2.1a1.5 1.5 0 1 1-1.2-2.7l5.3-2.2c.8-.4 1.7 0 2 .8ZM161 73.3c.3-.8 1.2-1.1 2-.8l2 .9 2-.9a1.5 1.5 0 0 1 1.6 2.5 1.5 1.5 0 0 1-1.5 2.5l-2.1-.9-2 .9a1.5 1.5 0 0 1-1.6-2.5c-.5-.4-.7-1-.4-1.7Zm10.5 4.5c.4-.8 1.2-1.2 2-.8l5.3 2.2a1.5 1.5 0 0 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm-13 0c.3.7 0 1.6-.8 2l-5.3 2.1a1.5 1.5 0 0 1-1.2-2.7l5.3-2.2c.8-.4 1.6 0 2 .8Zm23.6 4.4c.3-.8 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 1 1-1.1 2.8l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm-34.2 0c.3.8 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.1-2.8l5.2-2.2c.8-.3 1.7 0 2 .8Zm-10.5 4.4c.3.8 0 1.7-.8 2l-5.3 2.2a1.5 1.5 0 0 1-1.2-2.7l5.3-2.3c.8-.3 1.6 0 2 .8Zm55.2 0c.4-.7 1.2-1 2-.8l5.3 2.3a1.5 1.5 0 1 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm-65.8 4.5c.3.7 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.1-2.8l5.2-2.2c.8-.3 1.7 0 2 .8Zm76.4 0c.3-.8 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 1 1-1.1 2.8L204 93a1.5 1.5 0 0 1-.8-2Zm-87 4.4c.4.8 0 1.7-.8 2l-5.2 2.2A1.5 1.5 0 0 1 109 97l5.3-2.3c.7-.3 1.6 0 2 .8Zm97.6 0c.3-.7 1.2-1 2-.8L221 97a1.5 1.5 0 0 1-1.2 2.7l-5.2-2.2a1.5 1.5 0 0 1-.8-2ZM105.7 100c.3.7 0 1.6-.8 2l-5.3 2.2a1.5 1.5 0 1 1-1.2-2.8l5.3-2.2c.8-.3 1.7 0 2 .8Zm118.6 0c.3-.8 1.2-1.1 2-.8l5.3 2.2a1.5 1.5 0 0 1-1.2 2.8l-5.3-2.3a1.5 1.5 0 0 1-.8-2Zm-129.2 4.4c.4.8 0 1.7-.8 2l-5.2 2.2a1.5 1.5 0 0 1-1.2-2.8l5.3-2.2c.7-.3 1.6 0 2 .8Zm139.8 0c.3-.7 1.2-1.1 2-.8l5.2 2.2a1.5 1.5 0 1 1-1.2 2.8l-5.2-2.2a1.5 1.5 0 0 1-.8-2ZM84.6 109c.3.7 0 1.6-.8 2l-5.3 2.1a1.5 1.5 0 1 1-1.2-2.7l5.3-2.2c.8-.4 1.7 0 2 .8Zm160.8 0c.3-.8 1.2-1.2 2-.8l5.3 2.2a1.5 1.5 0 0 1-1.2 2.7l-5.3-2.2a1.5 1.5 0 0 1-.8-2Zm10.6 4.4c.3-.8 1.2-1.1 2-.8l2.6 1.1a1.5 1.5 0 1 1-1.2 2.8l-2.6-1.1a1.5 1.5 0 0 1-.8-2Zm-182 0c.3.8 0 1.7-.8 2l-2.6 1a1.5 1.5 0 1 1-1.2-2.7l2.7-1c.7-.4 1.6 0 2 .7Zm14.5 6.6c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3H90c-.8 0-1.5-.7-1.5-1.5Zm8.7 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 0 1 0 3H191c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3H214c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3h-2.9c-.8 0-1.5-.7-1.5-1.5Z"
						/>
						<g className="g_2">
							<path className="shape" d="M330 134a14 14 0 1 1-14-14h14v14Zm-3 0a11 11 0 1 1-11-11h11v11Z" />
							<path d="m312.2 137.5-.1 1.5h8.7v-2.2h-5.5a3 3 0 0 1 1-1l.8-.5a33.9 33.9 0 0 1 1.9-1l.8-.7.5-.9c.2-.3.3-.7.3-1.1a3 3 0 0 0-1.8-2.7 6.3 6.3 0 0 0-3.6-.2 6.8 6.8 0 0 0-3 1.6l1.5 1.7.5-.5.6-.4c.2-.2.4-.3.7-.3l.8-.2.9.2.6.5.2.7-.2.6-.6.5-1 .5a93 93 0 0 0-2.7 1.7l-.8 1-.5 1.2Z" />
						</g>
						<g className="g_d">
							<path
								className="shape"
								d="M242 134a14 14 0 0 1 14-14h14v14a14 14 0 1 1-28 0Zm3 0c0-6 5-11 11-11h11v11a11 11 0 0 1-22 0Z"
							/>
							<path d="M251.4 127.2V140h4.6c1.3 0 2.4-.3 3.4-.8s1.6-1.3 2.2-2.2c.5-1 .7-2.1.7-3.4 0-1.2-.2-2.3-.7-3.2-.4-1-1.1-1.8-2-2.3-1-.6-2.2-.9-3.6-.9h-4.6Zm8 4.2c.3.6.4 1.4.4 2.2 0 .8-.1 1.5-.4 2.2-.3.6-.7 1.1-1.3 1.5-.6.3-1.3.5-2 .5h-2.2v-8.4h2.1a4 4 0 0 1 2 .5c.6.4 1 .9 1.4 1.5Z" />
						</g>
						<g className="g_c">
							<path
								className="shape"
								d="M284 5c-6 0-11 5-11 11v11h11a11 11 0 0 0 0-22Zm0-3a14 14 0 0 0-14 14v14h14a14 14 0 1 0 0-28Z"
							/>
							<path
								fill="#494D5A"
								d="M277.9 15.5a6.5 6.5 0 0 1 3.6-5.8 6 6 0 0 1 2.7-.6c1.2 0 2.2.3 3 .8a5 5 0 0 1 2 2l-2 1.4a3 3 0 0 0-.8-1.2 3 3 0 0 0-1.1-.6 4 4 0 0 0-1.2-.2 3.4 3.4 0 0 0-2.8 1.4l-.7 1.4a5.5 5.5 0 0 0 0 3.1l.8 1.4 1.2 1c.5.2 1 .3 1.6.3.3 0 .8 0 1.2-.2a2 2 0 0 0 1-.6c.4-.3.7-.7.9-1.1l2 1.1c-.2.7-.6 1.2-1.2 1.7a6.8 6.8 0 0 1-4 1.4c-1 0-1.8-.3-2.5-.6a6.6 6.6 0 0 1-3.3-3.7c-.3-.8-.4-1.6-.4-2.4Z"
							/>
						</g>
						<g className="g_b">
							<path
								className="shape"
								d="M35 16c0 6 5 11 11 11h11V16a11 11 0 0 0-22 0Zm-3 0a14 14 0 0 0 14 14h14V16a14 14 0 1 0-28 0Z"
							/>
							<path d="M51 18.7a3 3 0 0 1-.5 1.8c-.4.5-1 .9-1.6 1.1-.6.3-1.3.4-2 .4h-6.2V9.2h6.9c.6 0 1 .2 1.5.5a3.5 3.5 0 0 1 .9 4.5c-.3.6-.8 1-1.4 1.2a3.2 3.2 0 0 1 2.4 3.3Zm-2.5-.5c0-.3 0-.6-.2-.8a1 1 0 0 0-.5-.6c-.2-.2-.5-.3-.8-.3h-3.8V20h3.7c.3 0 .6 0 .8-.2a1.7 1.7 0 0 0 .8-1.5Zm-5.3-6.9v3.3h3.3l.8-.2c.2-.2.4-.3.5-.6.2-.2.2-.5.2-.9 0-.3 0-.6-.2-.8a1.3 1.3 0 0 0-1.2-.8h-3.4Z" />
						</g>
						<g className="g_a">
							<path
								className="shape"
								d="M88 134a14 14 0 1 1-28 0v-14h14a14 14 0 0 1 14 14Zm-3 0a11 11 0 0 1-22 0v-11h11c6 0 11 5 11 11Z"
							/>
							<path d="M74.8 127.2h-2.5L67.5 140h2.6l1.2-3.2h4.4L77 140h2.6l-4.7-12.8Zm-1.3 2.6 1.8 5.3h-3.6l1.8-5.3Z" />
						</g>
						<g className="g_1">
							<path className="shape" d="M14 120a14 14 0 1 1-14 14v-14h14Zm0 3a11 11 0 1 1-11 11v-11h11Z" />
							<path d="M17.5 139v-2.2h-2.3v-8h-2.4l-.5.4-.8.5-.9.5a2 2 0 0 1-.8.2v2.3l.8-.1a6.3 6.3 0 0 0 1.7-.8l.5-.4v5.4h-2.6v2.2h7.3Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 15" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h3>
					<strong>Wall</strong> measurements
				</h3>

				<div className="measurtement_wrapper">
					{["ab", "bc", "cd"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					<strong>Cross</strong> measurements
				</h3>

				<div className="measurtement_wrapper">
					{["ac", "ad", "bd"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					Optional <strong>Distances</strong>
				</h3>

				<div className="measurtement_wrapper">
					{["1a", "d2"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<Render_status does_it_work={does_it_work} />

				{["ab", "bc", "cd", "ac", "ad", "bd", "1a", "d2"].map((key) => {
					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: parseInt(eval("measurtement_" + key)),
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="Square Bay" />
			</div>
		</div>
	);
}
